<template>
  <div class="provider">
    <div
      class="input-wrapper all-day-wrapper timing-wrapper repeat main-content"
      @click="show"
    >
      <div class="title-wrapper position-relative">
        <span class="ver-center">Provider</span>
      </div>
      <div class="content-wrapper position-relative">
        <span class="ver-center value-text r-0">
          {{ selectedValue }}
          <object
            v-if="providers.list && providers.list.length > 1"
            class="right-icon"
            :data="rightArrow"
            type="image/svg+xml"
          ></object>
        </span>
      </div>
    </div>

    <!-- General options -->
    <transition name="slide-left">
      <provider-vue v-if="display" :done="done" v-scroll-lock />
    </transition>
  </div>
</template>

<script>
import ProviderVue from "../Expand/Provider.vue";
import { mapGetters, mapMutations } from "vuex";
import { nameMixin } from "../../../../mixins/nameMixin.js";

export default {
  mixins: [nameMixin],
  props: {
    clientOrOtherClicked: Boolean
  },
  data() {
    return {
      display: false
    };
  },
  methods: {
    ...mapMutations({
      setSecondLevelHeaderActive: "setSecondLevelHeaderActive",
      setProvider: "setProvider" // Set provider selected Index
    }),
    show() {
      if (this.providers.list && this.providers.list.length > 1) {
        this.display = true;
        this.setSecondLevelHeaderActive(true);
      }
    },
    done() {
      this.display = false;
      this.setSecondLevelHeaderActive(false);
    },
    setCorrectProvider() {
      let correctIndex = false;
      for (let i = 0; i < this.providers.list.length; i++) {
        // Step 1: Set the current provider
        const currentProvider = this.providers.list[i];

        // Step 2: Check if current id is equal to provider id and provider has given permission
        if (
          currentProvider.id === this.selectedProviderID &&
          !currentProvider.permission_status &&
          !currentProvider.permission_id
        ) {
          correctIndex = i;
          break;
        }

        // Step 3: Check for remaining providers
        if (
          !currentProvider.permission_status &&
          !currentProvider.permission_id &&
          correctIndex === false
        ) {
          correctIndex = i;
        }
      }
      this.setProvider(correctIndex !== false ? correctIndex : 0);
    }
  },
  components: {
    ProviderVue
  },
  computed: {
    ...mapGetters({
      providers: "getProvider", // Get the provider details
      selectedProviderID: "getSelectedProviderID"
    }),
    providerList() {
      return this.providers.list;
    },
    /**
     * Returns the currently selected provider
     */
    selectedValue() {
      const provider = this.providers.list[this.providers.selectedIndex];
      if (provider) {
        return this.formatName(
          provider.firstName,
          provider.middleName,
          provider.lastName,
          provider.namePrefix,
          provider.nameSuffix
        );
      } else {
        return false;
      }
    },
    rightArrow() {
      return require("../../../../assets/svg/right-arrow.svg");
    }
  },
  watch: {
    /**
     * Weather the client or others is clicked
     */
    clientOrOtherClicked(value) {
      if (value) {
        this.done();
      }
    },
    providerList() {
      this.setCorrectProvider();
    }
  },
  created() {
    this.setCorrectProvider();
  }
};
</script>

<style scoped>
.ver-center {
  text-align: right;
}
</style>
